{
  "es": {
    "issue_category": {
      "labels": {
        "backup_category": "Categoría de sustitución",
        "category_name": "Nombre de la categoría",
        "delete_category": "¿Eliminar la categoría «{name}»?",
        "delete_category_disclaimer": "Todas las incidencias de posventa con esta categoría se reasignarán a la categoría que selecciones a continuación.",
        "integration_warning": "Tienes activa una integración con el módulo de posventa en tu plataforma. Si quieres crear o editar categorías, contáctanos.",
        "new_category": "Categoría"
      }
    }
  }
}
